// extracted by mini-css-extract-plugin
export default {"category_div":"Home_category_div__RSBV3","main":"Home_main__5Hw-T","carousel":"Home_carousel__iPThd"};